module.exports = __webpack_public_path__ + "static/avatar.5c027f44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar.jpg
// module id = 31
// module chunks = 35783957827783 70144966829960 114276838955818